import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";

const axios = require("axios").default;

function AddFC() {
  let params = useParams();
  const navigate = useNavigate();
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [error, setError] = useState("");
  const [setData, setSetData] = useState({});

  function AddCard(e) {
    e.preventDefault();
    const token = localStorage.getItem("token");

    axios
      .post(
        `https://application-flashcards.herokuapp.com/api/flashcards/create/`,
        {
          token,
          setID: setData[0].id,
          title,
          description,
        }
      )
      .then(function (response) {
        console.log(response);

        navigate(`/dashboard/set/${params.setname}`);
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  useEffect(() => {
    const token = localStorage.getItem("token");

    axios
      .post(
        `https://application-flashcards.herokuapp.com/api/sets/${params.setname}`,
        {
          token,
        }
      )
      .then(function (response) {
        console.log(response);

        if (response.data.length === 0) {
          setError("Cannot add card because set doesn't exist");
        } else {
          setSetData(response.data);
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  }, []);

  return (
    <>
      {error ? (
        <p>{error}</p>
      ) : (
        <form className="rounded-lg border-solid border border-slate-300 my-2 w-4/12 shadow-xl p-5 mx-auto mt-16 xsm:mx-auto xsm:my-5 xsm:w-10/12 md:w-6/12">
          <h2 className="font-semibold text-2xl my-3">Add Card</h2>
          <label for="set_title">Title:</label>
          <input
            className="w-full border border-slate-300 w-full mt-1 mb-3"
            id="set_title"
            type="text"
            onChange={(e) => {
              setTitle(e.target.value);
            }}
          />
          <label for="set_description">Description:</label>
          <textarea
            className="resize-none w-full border border-slate-300 w-full mt-1 mb-3"
            style={{ height: "10rem" }}
            id="set_description"
            onChange={(e) => {
              setDescription(e.target.value);
            }}
          />
          <div className="flex justify-end">
            <button
              className="w-2/12 text-white bg-red-400 border-solid border border-neutral-50 rounded p-1 hover:bg-red-500 "
              onClick={(e) => {
                e.preventDefault();
                navigate(-1);
              }}
            >
              Back
            </button>
            <button
              className="w-2/12 text-white bg-green-300 border-solid border border-neutral-50 rounded p-1 hover:bg-green-500 "
              type="submit"
              onClick={AddCard}
            >
              Add
            </button>
          </div>
        </form>
      )}
    </>
  );
}

export default AddFC;
